import React from "react";
import styled from "styled-components/macro";

export function WiresArrowLeft() {
  return (
    <Wrapper right={-25}>
      <Wire right={5} width={70} />
      <ArrowWrapper>
        <VerticalLine />
        <PointDown />
      </ArrowWrapper>
    </Wrapper>
  );
}
export function WiresArrowRight(isLast) {
  return (
    <Wrapper right={-40}>
      <Wire right={-110} width={112} />
      <ArrowWrapper>
        <VerticalLine />
        <PointDown />
      </ArrowWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  top: -15px;
  right: ${(props) => props.right}px;
  width: 70px;
  z-index: 999999;
`;
const ArrowWrapper = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const Wire = styled.div`
  border-top: 2px solid red;
  position: absolute;
  right: ${(props) => props.right}px;
  width: ${(props) => props.width}px;
`;
const VerticalLine = styled.div`
  height: 80px;
  background: red;
  width: 2px;
`;
const PointDown = styled.div`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 11px solid red;
`;
